import * as z from 'zod'
import {
    PRESS_RELEASES_FILTER_CONTENT_TYPE,
    PressReleaseListItem,
    PressReleaseSingleItem,
} from '../PressReleaseEntity.js'
import { GetApiContract } from './ApiContract.js'

export interface GetPressReleaseSingleItemRequest extends GetApiContract {
    Response: PressReleaseSingleItem
    ResponseJson: PressReleaseSingleItem
    QueryParameters: z.infer<typeof getPressReleaseListQueryParameterSchema>
}

export const getPressReleaseListQueryParameterSchema = z.object({
    companyId: z.string().optional(),
    contentType: z.enum(Object.values(PRESS_RELEASES_FILTER_CONTENT_TYPE)).optional(),
    limit: z.coerce.number(),
    page: z.coerce.number(),
    maxPublicationDate: z.iso.date().optional(),
    preferredLanguage: z.enum(['sv', 'en']).optional(),
    publicationDate: z.iso.date().optional(),
    search: z.string().optional(),
})

export interface GetPressReleaseListItemsRequest extends GetApiContract {
    Response: { data: Array<PressReleaseListItem>; totalCount: number }
    ResponseJson: { data: Array<PressReleaseListItem>; totalCount: number }
    QueryParameters: z.infer<typeof getPressReleaseListQueryParameterSchema>
}
